import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { useRates } from '@/features/alojamientos/hooks/useRates';
import { RateRow } from './RateRow';
import { useRoomTypes } from '@/features/alojamientos/hooks/useRoomTypes';
import { useBathroomTypes } from '@/features/alojamientos/hooks/useBathroomTypes';
import { useRoomCategories } from '@/features/alojamientos/hooks/useRoomCategories';
import { useCurrencyTypes } from '@/features/alojamientos/hooks/useCurrencyTypes';
import { DateField } from '@/components/form/fields/DateField';
import { useWatch } from 'react-hook-form';

interface RatesFormProps {
  readOnly?: boolean;
}

export const RatesForm = ({ readOnly = false }: RatesFormProps) => {
  const { rates, addRate, deleteRate, handleRateChange } = useRates();

  const { roomTypes, isLoading: isLoadingRoomTypes } = useRoomTypes();
  const { bathroomTypes, isLoading: isLoadingBathroomTypes } = useBathroomTypes();
  const { roomCategories, isLoading: isLoadingRoomCategories } = useRoomCategories();
  const { currencyTypes, isLoading: isLoadingCurrencyTypes } = useCurrencyTypes();

  const isLoading = isLoadingRoomTypes || isLoadingBathroomTypes || 
                   isLoadingRoomCategories || isLoadingCurrencyTypes;

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="rounded-md border">
        <div className="bg-gray-50 p-4 border-b">
          <div className="space-y-1.5">
            <h3 className="text-lg font-semibold">Gestión de Tarifas</h3>
            <div className="flex items-center gap-x-4 text-sm text-gray-600">
              <DateField
                name="rateStartDate"
                label="Vigencia desde"
                required
                minDate={new Date()}
              />
              <DateField
                name="rateEndDate"
                label="Vigencia hasta"
                required
                minDate={new Date()}
              />
            </div>
          </div>
        </div>

        <div className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-1/4">Tipo de Habitación</TableHead>
                <TableHead className="w-32">Tipo de Baño</TableHead>
                <TableHead className="w-32">Categoría</TableHead>
                <TableHead className="w-24">Moneda</TableHead>
                <TableHead>Precio</TableHead>
                <TableHead>Acciones</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rates.map((rate, index) => (
                <RateRow
                  key={index}
                  rate={rate}
                  index={index}
                  readOnly={readOnly}
                  roomTypes={roomTypes || []}
                  bathroomTypes={bathroomTypes || []}
                  roomCategories={roomCategories || []}
                  currencyTypes={currencyTypes || []}
                  onRateChange={handleRateChange}
                  onDelete={deleteRate}
                />
              ))}
            </TableBody>
          </Table>

          <div className="p-4 border-t">
            <Button 
              variant="outline" 
              className="gap-2"
              onClick={addRate}
              disabled={readOnly}
            >
              + Agregar Tarifa
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
